module.exports = __webpack_public_path__ + "img/visible-signin.1d4e1dd3.svg";